import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInputForm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconInputForm"><Path d="M9 20.25C9 20.6642 8.66421 21 8.25 21C7.83579 21 7.5 20.6642 7.5 20.25V3.75C7.5 3.33579 7.83579 3 8.25 3C8.66421 3 9 3.33579 9 3.75V20.25Z" fill="currentColor"/><Path d="M6 18H3.75C2.7835 18 2 17.2165 2 16.25V7.75C2 6.7835 2.7835 6 3.75 6H6V18Z" fill="currentColor"/><Path d="M20.25 6C21.2165 6 22 6.7835 22 7.75V16.25C22 17.2165 21.2165 18 20.25 18H10.5V6H20.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInputForm;
